import { createVNode as l, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RetractFilled.js";
import c from "../components/PfIcon.js";
const t = (r, e) => {
  const o = {
    ...r,
    ...e.attrs
  };
  return l(c, a(o, {
    icon: i
  }), null);
};
t.displayName = "RetractFilled";
t.inheritAttrs = !1;
export {
  t as default
};
